export default ($axios) => ({
    $axios,

    async fetch() {
        return await $axios.get('/services', {
            headers: {
                'X-Features': 'NEW_SERVICES',
            },
        })
    },

    async fetchById(id) {
        return await $axios.get(`/services/${id}`, {
            headers: {
                'X-Features': 'NEW_SERVICES',
            },
        })
    },

    async create(form) {
        return await $axios.post('/services', form, {
            headers: {
                'X-Features': 'NEW_SERVICES',
            },
        })
    },

    async update(id, form) {
        return await $axios.put(`/services/${id}`, form, {
            headers: {
                'X-Features': 'NEW_SERVICES',
            },
        })
    },

    async remove(id) {
        return await $axios.delete(`/services/${id}`)
    },

    async requestForDelete(id) {
        return await $axios.post(`/services/${id}/markToRemove`)
    },

    async updateIcon(id, form) {
        return await $axios.post(`/services/${id}/icon`, form)
    },
    async updateSmallIcon(id, form) {
        return await $axios.post(`/services/${id}/small-icon`, form)
    },
    async updateAnimation(id, form) {
        return await $axios.post(`/services/${id}/animation`, form)
    },
})
